export const colors = {
  $white: "#FFFCF2",
  $orange: "#fd8115ff",
  $black: "#252422",
  $lightGray: "#FFFCF2",
};
